(() => {
  const ids = [61111313301834, 61111313334602, 61111313367370];
  const giftId = 60891551727946;
  const marker = 'eyeliner-oct-2026';
  const start = Date.parse('2026-10-22T22:00:00Z');
  const end = Date.parse('2026-10-31T22:59:59Z');
  const active = now => now >= start && now < end;
  const count = cart => cart.items.reduce((sum, item) => sum + (ids.includes(Number(item.variant_id)) ? Number(item.quantity) : 0), 0);
  const managed = item => Number(item.variant_id) === giftId && item.properties?._lenoites_gift === marker;
  function giftUpdates(cart, now) {
    const updates = {};
    let allowance = active(now) && count(cart) >= 3 ? 1 : 0;
    for (const item of cart.items.filter(managed)) {
      const target = item.final_line_price === 0 ? Math.min(allowance, item.quantity) : 0;
      if (target !== item.quantity) updates[item.key] = target;
      allowance -= target;
    }
    return updates;
  }
  function additions(cart) {
    const items = ids.map(id => ({ id, quantity: 1 }));
    if (!cart.items.some(item => Number(item.variant_id) === giftId)) {
      items.push({ id: giftId, quantity: 1, properties: { _lenoites_gift: marker } });
    }
    return items;
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { active, count, giftUpdates, additions, start, end };
    return;
  }
  const configNode = document.getElementById('LenoitesEyelinerOfferConfig');
  if (!configNode || window.LenoitesEyelinerOffer) return;
  const config = JSON.parse(configNode.textContent);
  const clockStart = performance.now();
  const now = () => Number(config.serverNow) * 1000 + performance.now() - clockStart;
  const root = config.root.endsWith('/') ? config.root : config.root + '/';
  let busy = 0;
  let mutationCount = 0;
  let pending = Promise.resolve();
  let checkoutPass = false;
  let buttonBusy = false;
  const checkoutButtons = () => document.querySelectorAll('[name="checkout"], [href="/checkout"]');
  function setBusy(delta) {
    busy = Math.max(0, busy + delta);
    checkoutButtons().forEach(button => {
      if (busy) {
        if (!button.disabled) button.dataset.eyelinerLocked = 'true';
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
      } else {
        if (button.dataset.eyelinerLocked === 'true') button.disabled = false;
        delete button.dataset.eyelinerLocked;
        button.removeAttribute('aria-busy');
      }
    });
  }
  function announce(text) {
    let note = document.getElementById('LenoitesEyelinerOfferNotice');
    if (!note) {
      note = document.createElement('p');
      note.id = 'LenoitesEyelinerOfferNotice';
      note.setAttribute('role', 'status');
      note.style.cssText = 'position:fixed;bottom:20px;left:50%;transform:translateX(-50%);z-index:99999;background:#241511;color:#fff;padding:14px 20px;max-width:90vw;border-radius:6px;font:14px/1.5 Arial,sans-serif;';
      document.body.append(note);
    }
    note.textContent = text;
    note.hidden = false;
    clearTimeout(note.hideTimer);
    note.hideTimer = setTimeout(() => { note.hidden = true; }, 7000);
  }
  async function request(path, body) {
    const response = await fetch(root + path, body ? {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    } : { headers: { Accept: 'application/json' }, cache: 'no-store' });
    const data = await response.json();
    if (!response.ok || data.status >= 400 || data.errors) throw new Error(data.description || data.message || config.error);
    return data;
  }
  function reconcile(cart, sections = []) {
    const task = async () => {
      const updates = giftUpdates(cart, now());
      if (!Object.keys(updates).length) return cart;
      const result = await request('cart/update.js', { updates, sections, sections_url: location.pathname });
      announce(config.removed);
      return result;
    };
    const result = pending.then(task);
    pending = result.catch(() => {});
    return result;
  }
  async function syncVisible() {
    if (mutationCount || buttonBusy) return;
    setBusy(1);
    try {
      const cart = await request('cart.js');
      const updates = giftUpdates(cart, now());
      if (Object.keys(updates).length) {
        await reconcile(cart);
        location.reload();
      }
    } catch (error) {
      announce(config.error);
    } finally { setBusy(-1); }
  }
  window.LenoitesEyelinerOffer = {
    reconcile,
    beginCartChange() { mutationCount++; setBusy(1); },
    endCartChange() { mutationCount = Math.max(0, mutationCount - 1); setBusy(-1); }
  };
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-eyeliner-trio-add]');
    if (!button) return;
    event.preventDefault();
    if (buttonBusy || button.disabled || !active(now())) return;
    buttonBusy = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    const status = button.closest('[data-eyeliner-offer]').querySelector('[data-eyeliner-offer-status]');
    status.textContent = config.adding;
    setBusy(1);
    try {
      const cart = await request('cart.js');
      await request('cart/add.js', { items: additions(cart) });
      const updated = await request('cart.js');
      await reconcile(updated);
      location.assign(root + 'cart');
    } catch (error) {
      status.textContent = error.message || config.error;
      try { await reconcile(await request('cart.js')); } catch (_) {}
      button.disabled = !active(now());
    } finally {
      buttonBusy = false;
      button.removeAttribute('aria-busy');
      setBusy(-1);
    }
  });
  document.addEventListener('submit', async event => {
    if (checkoutPass || event.submitter?.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const form = event.target;
    const button = event.submitter;
    if (mutationCount || buttonBusy) { announce(config.wait); return; }
    setBusy(1);
    try {
      await pending;
      const cart = await request('cart.js');
      const result = await reconcile(cart);
      if (result !== cart) { location.assign(root + 'cart'); return; }
      setBusy(-1);
      checkoutPass = true;
      form.requestSubmit(button);
      checkoutPass = false;
    } catch (error) { announce(config.error); setBusy(-1); }
  }, true);
  function refreshVisibility() {
    document.querySelectorAll('[data-eyeliner-offer]').forEach(card => {
      if (!config.designMode) card.hidden = now() >= end;
      const button = card.querySelector('[data-eyeliner-trio-add]');
      if (button && !buttonBusy) button.disabled = !active(now()) || card.dataset.available !== 'true';
    });
  }
  refreshVisibility();
  window.addEventListener('pageshow', syncVisible);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) { refreshVisibility(); syncVisible(); }
  });
  const delay = end - now();
  if (delay > 0 && delay < 2147483647) setTimeout(() => { refreshVisibility(); syncVisible(); }, delay);
  const startDelay = start - now();
  if (startDelay > 0 && startDelay < 2147483647) setTimeout(refreshVisibility, startDelay);
})();
